import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterSupplyWorkNameTableDataAPI = createAsyncThunk("WaterSupplyWorkNameTableData", async ({ data }) => {
    const {
        M_Distri_WorkNameID,
        M_Distri_WorkTypeID,
        M_Distri_WorkPeriodID,
        WorkName,
        token,
        From,
        To,
        M_UserID,
        DashProjectTypeId,
        RoleID,
        handleWaterSupplyWorkNameExport
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WorkName_Select?M_Distri_WorkNameID=${M_Distri_WorkNameID ? M_Distri_WorkNameID : '0'}&M_Distri_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_Distri_WorkPeriodID ? M_Distri_WorkPeriodID : '0'}&WorkName=${WorkName ? WorkName : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_WorkName_Select?M_WS_WorkNameID=${M_Distri_WorkNameID ? M_Distri_WorkNameID : '0'}&M_WS_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_Distri_WorkPeriodID ? M_Distri_WorkPeriodID : '0'}&WorkName=${WorkName ? WorkName : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyWorkNameExport && handleWaterSupplyWorkNameExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyWorkNameTableDataSlice = createSlice({
    name: "WaterSupplyWorkNameTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkNameTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyWorkNameTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyWorkNameTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyWorkNameTableDataReducer = WaterSupplyWorkNameTableDataSlice.reducer


export const WaterSupplyWorkNameExportTableDataAPI = createAsyncThunk("WaterSupplyWorkNameExportTableData", async ({ data }) => {
    const {
        M_Distri_WorkNameID,
        M_Distri_WorkTypeID,
        M_Distri_WorkPeriodID,
        WorkName,
        token,
        From,
        To,
        M_UserID,
        DashProjectTypeId,
        RoleID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WorkName_Select?M_Distri_WorkNameID=${M_Distri_WorkNameID ? M_Distri_WorkNameID : '0'}&M_Distri_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_Distri_WorkPeriodID ? M_Distri_WorkPeriodID : '0'}&WorkName=${WorkName ? WorkName : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_WorkName_Select?M_WS_WorkNameID=${M_Distri_WorkNameID ? M_Distri_WorkNameID : '0'}&M_WS_WorkTypeID=${M_Distri_WorkTypeID ? M_Distri_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_Distri_WorkPeriodID ? M_Distri_WorkPeriodID : '0'}&WorkName=${WorkName ? WorkName : ''}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyWorkNameExportTableDataSlice = createSlice({
    name: "WaterSupplyWorkNameExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkNameExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterSupplyWorkNameExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterSupplyWorkNameExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyWorkNameExportTableDataReducer = WaterSupplyWorkNameExportTableDataSlice.reducer


// InsertUpdate Table Data

export const WaterSupplyWorkNamePostDataAPI = createAsyncThunk("WaterSupplyWorkNamePostData", async ({ data }) => {
    const {
        M_Distri_WorkNameID,
        M_WS_WorkNameID,
        M_Distri_WorkTypeID,
        M_Distri_WorkPeriodID,
        WorkCode,
        WorkName,
        PenaltyPeriod,
        BenchMark,
        Penalty_Description,
        Penalty_Values,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == 6 && RoleID != '16') {
        formdata.append("M_Distri_WorkNameID", M_Distri_WorkNameID);
        formdata.append("M_Distri_WorkTypeID", M_Distri_WorkTypeID);
        formdata.append("M_Distri_WorkPeriodID", M_Distri_WorkPeriodID);
    } else {
        formdata.append("M_WS_WorkNameID", M_WS_WorkNameID);
        formdata.append("M_WS_WorkTypeID", M_Distri_WorkTypeID);
        formdata.append("M_WS_WorkPeriodID", M_Distri_WorkPeriodID);
    }

    formdata.append("WorkCode", WorkCode);
    formdata.append("WorkName", WorkName);
    formdata.append("PenaltyPeriod", PenaltyPeriod);
    formdata.append("BenchMark", BenchMark);
    formdata.append("Penalty_Description", Penalty_Description);
    formdata.append("Penalty_Values", Penalty_Values);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/Post_WEB_M_Distri_WorkName_InsertUpdate`
    } else {
        url = `${BaseUrl}/Master/Post_WEB_M_WS_WorkName_InsertUpdate`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WaterSupplyWorkNamePostDataSlice = createSlice({
    name: "WaterSupplyWorkNamePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkNamePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyWorkNamePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyWorkNamePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyWorkNamePostDataReducer = WaterSupplyWorkNamePostDataSlice.reducer



// // // Delete Table Data

export const WaterSupplyWorkNameMasterDeleteAPI = createAsyncThunk("WaterSupplyWorkNameMasterDelete", async ({ data }) => {

    const {
        M_Distri_WorkNameID,
        M_WS_WorkNameID,
        M_Distri_WS_PipeLineID,
        M_UserID,
        handleIsPost,
        token,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == 6 && RoleID != '16') {
        formdata.append("M_Distri_WorkNameID", M_Distri_WorkNameID);
    } else {
        formdata.append("M_WS_WorkNameID", M_WS_WorkNameID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == 6 && RoleID != '16') {
        url = `${BaseUrl}/Master/WEB_M_Distri_WorkName_Delete`
    } else {
        url = `${BaseUrl}/Master/WEB_M_WS_WorkName_Delete`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WaterSupplyWorkNameMasterDeleteSlice = createSlice({
    name: "WaterSupplyWorkNameMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyWorkNameMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterSupplyWorkNameMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WaterSupplyWorkNameMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyWorkNameMasterDeleteReducer = WaterSupplyWorkNameMasterDeleteSlice.reducer